import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateAtividadeObraColumns
 */

type Props = {
  onActionEditar: (idEstruturaOrganizacional: number | null, openState: boolean) => void,
  onActionDeletar: (idEstruturaOrganizacional: number | null, openState: boolean) => void,
};

export const GenerateAtividadeObraColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Atividade",
      flex: 2,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "funcionarioResp",
      filterable: false,
      headerName: "Responsável",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "funcionarioCoresp",
      filterable: false,
      headerName: "Coresponsável",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'idAtividadeObra',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}